import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { createUser } from '../../services/Auth/userService';
import ReusableForm from '../../components/ReusableForm';
import projectLogo from '../../public/Logo.png';
import '../styles/FormPageStyles.css';

const RegisterManualStep2 = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    contrasena: '',
    confirmarContrasena: ''
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!formData.contrasena || !formData.confirmarContrasena) {
      setError('La contraseña y la confirmación son obligatorias.');
      return;
    }
    if (formData.contrasena.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }
    if (formData.contrasena !== formData.confirmarContrasena) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setIsSubmitting(true);

    // Rol fijo: 2
    const payload = {
      rolId: 2,
      contrasena: formData.contrasena
    };

    try {
      const result = await createUser(payload);
      if (result.success) {
        setSuccessMessage('¡Cuenta creada con éxito! Ahora puedes iniciar sesión.');
        setTimeout(() => navigate('/auth/login'), 1200);
      } else {
        setError(result.message || 'Error al crear el usuario.');
      }
    } catch (err) {
      setError('Error al procesar la solicitud.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const afterButtonLinks = (
    <div className="login-page-links-container">
      <div className="form-link-item">
        <p>
          ¿Ya tienes cuenta? <Link to="/auth/login" className="form-link">Inicia sesión</Link>
        </p>
      </div>
    </div>
  );

  return (
    <ReusableForm
      title="Crear Cuenta - Paso 2"
      imageSrc={projectLogo}
      error={error}
      successMessage={successMessage}
      handleSubmit={handleSubmit}
      submitButtonText={isSubmitting ? 'Creando Cuenta...' : 'Crear Cuenta'}
      submitButtonDisabled={isSubmitting}
      afterButtonContent={afterButtonLinks}
    >
      <div className="form-group">
        <input
          type="password"
          name="contrasena"
          placeholder="Contraseña*"
          value={formData.contrasena}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <input
          type="password"
          name="confirmarContrasena"
          placeholder="Confirmar Contraseña*"
          value={formData.confirmarContrasena}
          onChange={handleChange}
          required
        />
      </div>
    </ReusableForm>
  );
};

export default RegisterManualStep2;


